import { useState } from 'react';

import JobList from '../../components/JobList';

const LegalWorkExperiencePage = () => {
  const [jobCount, setJobCount] = useState(0);

  return (
    <div>
      <div className="grid__container">
        <div className="grid__row content-block" style={{ paddingBottom: '0' }}>
          <div className="grid__column--8 grid__column--mobile-12">
            <p className="page-sub-title">Early careers</p>
            <h1 className="teams-header">Legal Work Experience</h1>
            <a
              href={jobCount === 0 ? undefined : '#job-list-section'}
              className={`button${jobCount === 0 ? ' button--disabled' : ''}`}
              aria-disabled={jobCount === 0}
              tabIndex={jobCount === 0 ? -1 : undefined}
              id="explore-jobs-button"
            >
              Explore jobs
            </a>
          </div>
        </div>
      </div>
      <div className="grid__container">
        <div className="grid__row">
          <div className="grid__column--padded grid__column--tablet-12">
            <p>
              Curious about a career in law — but not quite sure where it could
              take you?
            </p>
            <p>
              At Skyscanner, our Legal team helps power a global travel platform
              used by millions. From supporting big decisions to keeping
              everything running smoothly behind the scenes, they&#39;re a vital
              part of how we build better travel experiences.
            </p>
            <p>Now, we&#39;re opening the door for you to see it up close.</p>
          </div>
        </div>
        <hr />
      </div>
      <section className="grid__container page__section">
        <div className="grid__row row--top-align content-block">
          <div className="grid__column--6 grid__column--tablet-12 photo-container">
            <img
              className="photo"
              alt="Team member holding up a skyscanner sign sitting in a planter"
              src="https://content.skyscnr.com/m/26ab94a543cc9079/original/Real-Deal-EDI-2.jpg"
            />
          </div>
          <div className="grid__column--6 grid__column--tablet-12">
            <h2>A first step into the world of law</h2>
            <p>
              Our Legal Work Experience Programme is designed for students at
              the very start of their journey — whether you&#39;re finishing
              school or just beginning university.
            </p>
            <p>
              It&#39;s a two-week, paid placement where you&#39;ll get a real
              feel for what in-house law looks like inside a global tech
              company. No prior experience needed — just curiosity, enthusiasm,
              and a willingness to learn.
            </p>
            <p>
              Because we believe careers in law should be more accessible — and
              that potential can come from anywhere.
            </p>
          </div>
        </div>
      </section>
      <section className="grid__container page__section">
        <div className="grid__row row--top-align">
          <div className="grid__column--6 grid__column--tablet-12 photo-container--left mobile-and-tablet-only">
            <img
              className="photo"
              alt="Team members poking their heads out of call booths"
              src="https://content.skyscnr.com/m/27ede440e65abcfc/original/Real-Deal-EDI-2.jpg"
            />
          </div>
          <div className="grid__column--6 grid__column--tablet-12">
            <h2>What you&#39;ll experience</h2>
            <p>This isn&#39;t about watching from the sidelines.</p>
            <p>
              You&#39;ll spend two weeks embedded in our Legal team, getting
              involved in day-to-day work, shadowing experienced team members,
              and learning how legal supports every part of the business.
            </p>
            <p>Along the way, you&#39;ll:</p>
            <ul>
              <li>Gain hands-on experience in an in-house legal environment</li>
              <li>Shadow team members and see real work in action</li>
              <li>Build confidence in a supportive, welcoming space</li>
              <li>Get practical insight to help shape your future career</li>
            </ul>
            <p>
              And because we want to remove barriers where we can, the programme
              is paid, with a laptop and meal vouchers provided.
            </p>
            <p>
              <strong>Locations:</strong> Edinburgh, London, and Glasgow
            </p>
          </div>
          <div className="grid__column--6 grid__column--tablet-12 photo-container--right">
            <img
              className="photo desktop-only"
              alt="Team members poking their heads out of call booths"
              src="https://content.skyscnr.com/m/27ede440e65abcfc/original/Real-Deal-EDI-2.jpg"
            />
          </div>
        </div>
      </section>
      <section className="grid__container">
        <div className="grid__row row--top-align content-block">
          <div className="grid__column--5 grid__column--tablet-12 photo-container">
            <img
              className="photo"
              alt="Team members hanging out and posing"
              src="https://content.skyscnr.com/m/77efa164efaa4621/original/EVP-The-Real-Deal.jpg"
            />
          </div>
          <div className="grid__column--7 grid__column--tablet-12">
            <h2>Ready to explore more?</h2>
            <p>
              Check out the full programme details and apply below. Your journey
              into law starts here.
            </p>
            <a
              href={jobCount === 0 ? undefined : '#job-list-section'}
              className={`button${jobCount === 0 ? ' button--disabled' : ''}`}
              aria-disabled={jobCount === 0}
              tabIndex={jobCount === 0 ? -1 : undefined}
            >
              Apply now
            </a>
          </div>
        </div>
      </section>
      <JobList
        department="Legal Work Experience"
        setJobCountCallback={(count) => setJobCount(count)}
      />
    </div>
  );
};

export default LegalWorkExperiencePage;
